module.exports = __webpack_public_path__ + "img/edit_w.964644c9.svg";